function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon';
var prefixCls = 'eui-progress';

var Progress = /*#__PURE__*/function (_React$Component) {
  _inherits(Progress, _React$Component);

  var _super = _createSuper(Progress);

  function Progress() {
    _classCallCheck(this, Progress);

    return _super.apply(this, arguments);
  }

  _createClass(Progress, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          status = _this$props.status,
          percent = _this$props.percent,
          showInfo = _this$props.showInfo;
      var progressInfo;
      var fullCls = '';

      if (parseInt(percent, 10) === 100) {
        status === 'success';
      }

      if (showInfo === true) {
        if (status === 'exception') {
          progressInfo = /*#__PURE__*/React.createElement("span", {
            className: "".concat(prefixCls, "-line-text")
          }, /*#__PURE__*/React.createElement(Icon, {
            value: "fail"
          }));
        } else if (status === 'success') {
          progressInfo = /*#__PURE__*/React.createElement("span", {
            className: "".concat(prefixCls, "-line-text")
          }, /*#__PURE__*/React.createElement(Icon, {
            value: "success"
          }));
        } else {
          progressInfo = /*#__PURE__*/React.createElement("span", {
            className: "".concat(prefixCls, "-line-text")
          }, percent, "%");
        }
      } else if (status === 'loading') {
        fullCls = " ".concat(prefixCls, "-line-full");
      } else {
        fullCls = " ".concat(prefixCls, "-line-full");
      }

      var percentStyle = {
        width: "".concat(percent, "%")
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-line status-").concat(status).concat(fullCls)
      }, progressInfo, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-line-outer")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-line-inner")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-line-bg"),
        style: percentStyle
      }))));
    }
  }]);

  return Progress;
}(React.Component);

_defineProperty(Progress, "propTypes", {
  status: PropTypes.oneOf(['normal', 'exception', 'active', 'success', 'loading']),
  showInfo: PropTypes.bool,
  percent: PropTypes.number
});

_defineProperty(Progress, "defaultProps", {
  percent: 0,
  status: 'normal',
  // exception active success loading
  showInfo: true
});

export default Progress;